
import { Injectable, Renderer2 } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  constructor(
    public  renderer              : Renderer2,
  ) {}

// onkeydown method focus next input start
onKeydown(event: KeyboardEvent, nextElement:string,previousElement?:string) {

    if (event.key === 'Enter') {
      event.preventDefault();
      let element = document.getElementById(nextElement) as HTMLInputElement;
      // const element = this.renderer?.selectRootElement(nextInput);
      element?.focus();
    // element?.select();
    }
    if(event.key=='Tab' && nextElement!=undefined){
      event.preventDefault();
      let element = document.getElementById(nextElement) as HTMLInputElement;
      element?.focus();
    }
    else if (event.key === 'Backspace' && event.shiftKey) {
      event.preventDefault();
      // Your logic for Shift + Backspace
      console.log('Shift + Backspace pressed');
    }
  }
 // onkeydown method focus next input end


isBase64Image(imageUrl: string | null | undefined): string | undefined {
  if (!imageUrl)
    return '';

  if (/^data:image\/[a-zA-Z]*;base64,/.test(imageUrl) || imageUrl?.startsWith(environment?.baseUrl) || imageUrl == null || imageUrl?.trim() === "")
    return imageUrl;
  else
    return environment.baseUrl + imageUrl;
}

formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00`;
}



openPrintDialog(htmlContent) {
  console.log(htmlContent.toString)
  if(htmlContent == undefined || htmlContent == null || htmlContent == "") {
    throw new Error("Content Not Found");
    
  } else {
    // Create a hidden iframe
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    // Set iframe content
    const iframeDocument = iframe.contentWindow?.document;
    if (iframeDocument) {
      iframeDocument.open();
      iframeDocument.write(htmlContent);
      iframeDocument.close();
      // Wait for the iframe to load its content before triggering print
      const waitForLoad = setInterval(() => {
        if (iframe.contentWindow?.document.readyState === 'complete') {
          clearInterval(waitForLoad);
          iframe.contentWindow?.print();
          document.body.removeChild(iframe); // Clean up by removing the iframe
        }
      }, 100);
    } else {
      console.error('Failed to open print window');
    }
  }
}

decodeHtml(html: string): string {
  // Create a new textarea element
  const textarea = document.createElement('textarea');
  // Set its HTML content to the encoded HTML string
  textarea.innerHTML = html;
  // The textContent property of the textarea will contain the decoded HTML
  return textarea.textContent || '';
}


 base64ToPdfAndPrint(base64: string): void {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });

  const blobUrl = URL.createObjectURL(blob);
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = blobUrl;

  iframe.onload = () => {
    setTimeout(() => {
      iframe.focus();
      iframe.contentWindow?.print();
    }, 1);
  };

  document.body.appendChild(iframe);

}
  public markFormAsTouchedAndDirty(form: NgForm) {
    Object.keys(form?.controls).forEach(field => {
      const control = form?.controls[field];
      control?.markAsTouched({ onlySelf: true });
      control?.markAsDirty({ onlySelf: true });
    });
  }

 listen(eventName: string, callback: (data: any) => void) {
  window.addEventListener(eventName, (event: any) => {
    callback(event.detail);
  });
}


}